import { render, staticRenderFns } from "./OrderStatusProcessing.vue?vue&type=template&id=5f28b83c&"
import script from "./OrderStatusProcessing.vue?vue&type=script&lang=js&"
export * from "./OrderStatusProcessing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports